export enum DisplayEventType {
    periodStart = "periodStart",
    periodEnd = "periodEnd",
    nonPlayingPeriod = "nonPlayingPeriod",
    other = "other",
}
